// layouts/Customization/components/CustomLogicDetails.js
import React from 'react';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import { Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';
import { grey } from '@mui/material/colors';

function CustomLogicDetails({ customLogic, onClose }) {
  return (
    <Card>
      <ArgonBox p={3} display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <ArgonTypography variant="h6">{customLogic.type}</ArgonTypography>
        <Button variant="contained" color="info" onClick={onClose}>
          Back to Custom Logic
        </Button>
      </ArgonBox>
      <ArgonBox p={3}>
        <ArgonTypography variant="h6" fontWeight="bold" mb={2}>
          Lines
        </ArgonTypography>
        <TableContainer component={Paper} sx={{ mb: 3 }}>
          <Table aria-label="custom logic lines table">
            <TableHead sx={{ display: 'contents' }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Description</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customLogic.lines.map((line, index) => (
                <TableRow key={index}>
                  <TableCell>{line.name}</TableCell>
                  <TableCell>{line.description}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <ArgonTypography variant="h6" fontWeight="bold" mb={2}>
          Records
        </ArgonTypography>
        <TableContainer component={Paper}>
          <Table aria-label="custom logic records table">
            <TableHead sx={{ display: 'contents' }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Description</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customLogic.records.map((record, index) => (
                <TableRow key={index}>
                  <TableCell>{record.Name}</TableCell>
                  <TableCell>{record.Description}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </ArgonBox>
    </Card>
  );
}

export default CustomLogicDetails;
